<div class="flex justify-content-center align-items-center lg:px-12 md:px-8 px-6 py-8">
  <div class="surface-card p-4 shadow-2 border-round w-full lg:w-4">
    <div class="text-center mb-5">
      <div class="relative">
      </div>
      <div class="text-900 text-3xl font-medium mb-3">Page de connexion</div>
    </div>

    <div>
      <form name="form" [formGroup]="loginForm">
        <div class="no-padding n-margin" *ngIf="isDev">
          <div>
            <label for="email"
                   class="block text-900 font-medium mb-2">Email</label>
            <input type="text"
                   name="email"
                   id="email"
                   formControlName="email"
                   class="form-control w-full mb-3">
            <div *ngIf="submitted && loginForm.controls.email.invalid && (loginForm.controls.email.dirty || loginForm.controls.email.touched)"
                 class="alert alert-danger">
              <div *ngIf="loginForm.controls.email.errors?.['required']">
                Email is required.
              </div>
            </div>
          </div>
          <div>
            <label for="password"
                   class="block text-900 font-medium mb-2">Password</label>
            <input type="password"
                   name="password"
                   id="password"
                   formControlName="password"
                   class="w-full mb-3">
            <div *ngIf="submitted && loginForm.controls.password.invalid && (loginForm.controls.password.dirty || loginForm.controls.password.touched)"
                 class="alert alert-danger">
              <div *ngIf="loginForm.controls.password.errors?.['required']">
                Password is required.
              </div>
            </div>
          </div>
          <div class="text-center p-2">
            <button pButton (click)="submitForm()" class="mx-auto d-block col-6 text-center" label="Connexion"></button>
          </div>
        </div>
        <hr>
        <div class="text-center p-2">
          <h5 class="text-center">Microsoft 365</h5>
          <button pButton label="Connexion avec office 365" class="mx-auto d-block col-6 p-button-secondary" (click)="loginSso()" ></button>
        </div>
        <div
          *ngFor="let error of errors">
          <p-message severity="error"
                     text="{{error}}"></p-message>
        </div>
      </form>
    </div>
  </div>
</div>
